import { takeLatest } from 'redux-saga/effects';

import {
  GET_NEWS_FEED,
  REQUEST_RATING_NEWS,
  GET_PREFERENCES,
  SAVE_PREFERENCES,
} from './newsFeedActions';

import {
  fetchNewsFeedSaga,
  requestRatingNewsSaga,
  fetchPreferencesSaga,
  getInitialPreferencesSaga,
  savePreferencesSaga,
} from './newsFeedSaga';

export function* newsFeedWatchers() {
  yield getInitialPreferencesSaga();

  yield takeLatest(GET_PREFERENCES, fetchPreferencesSaga);
  yield takeLatest(SAVE_PREFERENCES, savePreferencesSaga);
  yield takeLatest(REQUEST_RATING_NEWS, requestRatingNewsSaga);
  yield takeLatest(GET_NEWS_FEED, fetchNewsFeedSaga);
}
